"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _timekeeper = _interopRequireDefault(require("timekeeper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 * Gets the current date and time for the app. In production this will always be the current date and time but in
 * development and staging this can be overridden by a 'timetravel' config parameter.
 *
 * This parameter should look like this in config/schema.json:
 *   "timetravel": {
 *     "format": "date-time",
 *     "required": false,
 *     "type": "string"
 *   }
 *
 * Then in local.config.json (for example) you could override like so:
 *   "timetravel": "2018-07-01T14:05:00+10:00"
 *
 * This allows for testing how code behaves before/after certain key dates.
 *
 * @param {Object} config - A config store from @ahmdigital/config
 * @returns {Date} The current date and time for the app
 */
var getAppDate = function getAppDate(config) {
  var timetravel = config.get('timetravel');
  if ((0, _fp.isString)(timetravel) && !_timekeeper["default"].isKeepingTime()) {
    _timekeeper["default"].travel(timetravel);
  }
  return new Date();
};
var _default = exports["default"] = getAppDate;
module.exports = exports.default;